import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../actions/appDataActions';
import * as trackingDataActions from '../actions/trackingDataActions';
import * as appHelper from '../helpers/appHelper';
import {getScreenComponentByType} from '../helpers/componentHelper';
import * as enviromentHelper from '../helpers/environmentHelper';

class AppScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            bite: this.props.bite,
            lesson_location: this.props.trackingData.lesson_location,
            env: enviromentHelper.getEnvironment(),
            screen: {},
            screen_type: {},
            searchForScreen: true,
            setFocus: false
        };
        this.getScreen = this.getScreen.bind(this);
        this.getScreenType = this.getScreenType.bind(this);
        this.componentWatcher = this.componentWatcher.bind(this);
        this.setElFocus = this.setElFocus.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        this.getScreen();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lesson_location !== nextProps.trackingData.lesson_location) {
            this.setState(
                {
                    lesson_location: nextProps.trackingData.lesson_location,
                    screen_type: Object.assign({}, {})
                }
            );
        }
    }

    componentDidUpdate() {
       if(typeof this.state.screen_type.component === 'undefined' && this.state.searchForScreen){
           this.getScreen();
        }

        if(this.state.setFocus){
           this.setElFocus();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher(){
        let env = enviromentHelper.getEnvironment();
        if((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)){
            this.setState({env: env});
        }
    }

    getScreen() {
        let screen_id = this.state.lesson_location;
        let screen = Object.assign({}, this.state.bite.screens[0]);
        if (!isNaN(parseInt(screen_id))) {
            screen = Object.assign({}, appHelper.getBiteScreen(this.state.bite.bite_id, screen_id));
            if(appHelper.isDefined(screen.screen_id)){
                this.getScreenType(screen);
                this.setState({searchForScreen: true});
            }else{
                let bite_id = appHelper.getBiteByScreenId(screen_id);
                let bite = appHelper.getBiteById(bite_id);
                this.setState({bite: Object.assign({},bite)});
                this.context.router.push(`/${bite_id}`);
            }
        }else{
            this.getScreenType(screen);
            this.setState({searchForScreen: true});
        }


    }

    getScreenType(screen) {
        let screenType = Object.assign({}, getScreenComponentByType(screen.screen_type));
        this.setState({
            screen: Object.assign({}, screen),
            screen_type: Object.assign({}, screenType),
            setFocus: true
        });
        this.props.actions.clearAudio();
    }

    setElFocus(){
        let focusEl = document.getElementById("appScreen");
        focusEl.focus();
        this.setState({setFocus: false});
    }

    render() {
        let Component = this.state.screen_type.component;
        if(this.state.screen_type.isAdaptive){
            if(appHelper.isDefined(this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size]) && appHelper.isDefined(this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation])){
                Component = this.state.screen_type.adaptiveComponentSizes[this.state.env.window.size][this.state.env.window.orientation];
            }else{
                Component = this.state.screen_type.component;
            }
        }
        return (
            <div className="app-screen" id="appScreen" role="main" tabIndex="0">


                {appHelper.isDefined(Component)
                    ?
                    <Component screen={this.state.screen} biteCallbacks={this.props.biteCallbacks}/>
                    :
                    null
                }

            </div>
        );
    }
}

/*

 <div className="top-level">{this.state.env.window.size} - {this.state.env.window.orientation}</div>
 */

AppScreen.propTypes = {
    bite: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

AppScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AppScreen);



/** WEBPACK FOOTER **
 ** ./src/components/AppScreen.js
 **/